import React from 'react'
import './hobbie-style.css'

const Hobbie = ({ name }) => (<li className='hobbie'>{name}</li>)

export default Hobbie